import React from 'react';
import { useDialog } from '../context/DialogContext';
import styles from '../styles/historyButton.module.css';

interface HistoryButtonProps {
  stepNumber: number;
  stepTitle: string;
  stepData: any;
  isOptedOut: boolean;
  onStepUpdated?: () => void;
}

const HistoryButton: React.FC<HistoryButtonProps> = ({
  stepNumber,
  stepTitle,
  stepData,
  isOptedOut,
  onStepUpdated
}) => {
  const { showAlert } = useDialog();

  const handleClick = () => {
    if (isOptedOut) {
      showAlert({
        message: 'Date tracking disabled\n\nYou can re-enable date tracking in your profile settings.',
        variant: 'info'
      });
    } else {
      // This will be handled by the parent component that renders the HistoryModal
      // The button click should trigger the modal to open
      if (onStepUpdated) {
        onStepUpdated();
      }
    }
  };

  return (
    <button 
      className={`${styles.historyButton} ${isOptedOut ? styles.disabled : ''}`}
      onClick={handleClick}
      title={isOptedOut ? "Date tracking disabled" : "View timeline"}
      tabIndex={-1}
    >
      📅
    </button>
  );
};

export default HistoryButton; 